import { render, staticRenderFns } from "./Individuel.vue?vue&type=template&id=2812e4b8&"
import script from "./Individuel.vue?vue&type=script&lang=js&"
export * from "./Individuel.vue?vue&type=script&lang=js&"
import style0 from "./Individuel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports